import React from 'react';
import { useStyle } from './PrequalStyle.js';
import { scrollToTop } from './EirPrequalUtil.js';

export default function EirFixedBundleCardHeader(props) {
    const classes = useStyle({
        themeColor: props.themeColor,
        themeColorOnHover: props.themeColorOnHover,
        themeColorForBroadbandCards: props.themeColorForBroadbandCards,
        themeColorForBroadbandCardsHover: props.themeColorForBroadbandCardsHover,
        useBroadbandCardColor: props.useBroadbandCardColor,
    });
    const headerHoverImage = props.headerImg.replace(/(\.[\w\d_-]+)$/i, '_active$1');
    const handleBrokenImage = event => {
        if (!event.target.src.includes(props.headerImg)) {
            event.target.src = props.headerImg;
        }
    };
    return (
        <div
            className={classes.BundleCardHeader}
            onClick={e => {
                e.stopPropagation();
                scrollToTop();
            }}>
            <img
                className={classes.BundleCardHeaderImage}
                src={
                    props.changeImageOnHover
                        ? !props.buttonState
                            ? props.headerImg
                            : headerHoverImage
                        : props.headerImg
                }
                onError={handleBrokenImage}
            />
            <div
                className={
                    !props.buttonState
                        ? classes.BundleCardHeaderContainer
                        : classes.BundleCardHeaderContainerHover
                }>
                {props.contractLength} Month Contract
            </div>
        </div>
    );
}
